export class OfferItemModel {
  offerItemId: number;
  itemName: string;
  primaryImage: string;
  itemImages: string[]; // converted from comma-separated string
  price: number;
  description: string;
  infoLinkTitle: string;
  infoLinkUrl: string;
  infoLinkText: string;
  availableRegion: string;

  constructor(data: {
    offerItemId: number;
    itemName: string;
    primaryImage: string;
    itemImages: string;
    price: number;
    description: string;
    infoLinkTitle?: string;
    infoLinkUrl?: string;
    infoLinkText?: string;
    availableRegion?: string;
  }) {
    this.offerItemId = data.offerItemId;
    this.itemName = data.itemName;
    this.primaryImage = data.primaryImage;
    // Split comma-separated string into array
    this.itemImages = data.itemImages.split(",").map(img => img.trim());
    this.price = data.price;
    this.description = data.description;
    this.infoLinkTitle = data.infoLinkTitle ?? "";
    this.infoLinkUrl = data.infoLinkUrl ?? "";
    this.infoLinkText = data.infoLinkText ?? "";
    this.availableRegion = data.availableRegion ?? "";
  }
}
